import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'app-eye-witness',
  templateUrl: './eye-witness.component.html',
  styleUrls: ['./eye-witness.component.scss'],
})
export class EyeWitnessComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  notesIcon =
    this.RESOURCE_SERVER_URL +
    '/assets/images/process-claims/icons/menu_book.svg';
  addIcon = this.RESOURCE_SERVER_URL + '/assets/images/addPurple.svg';
  addCircleIcon = this.RESOURCE_SERVER_URL + '/assets/images/add.svg';
  deleteIcon = this.RESOURCE_SERVER_URL + '/assets/images/delete.svg';

  selectedCircleIndex: number = 0;
  claimId: any;
  isLoading: boolean = false;
  getEyewitnessDetails: any;
  selectedEyewitnessUUID: any;
  eyeWitnessDetail: any = {};
  eyewitnessDetailList: any = [];
  dialCodesArr: any = [];
  temp: any = [];

  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<EyeWitnessComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  async ngOnInit() {
    this.claimId = this.data.claimID;
    await this.initialDropdown();
    await this.getAllEyewitness();
    await this.getAllEyewitnessById(0);
  }
  async onCloseDialog() {
    this.dialogRef.close();
  }
  async initialDropdown() {
    this.isLoading = true;
    try {
      let url =
        environment.API_CONFIG_COMMON +
        'lookup?list=Occupation,Country,occupationCodes,countryCodes,DialCode';
      let dropDownResponse = await this.commonService.commonGet(url);
      this.dialCodesArr = dropDownResponse.body.DialCode;
      this.isLoading = false;
    } catch (err) {
      console.log('Get API Error - Claim Data', err);
      this.isLoading = false;
    }
  }

  async onDataInput(event, key, length) {
    let allow = true;
    if (event.length > length && length) {
      allow = false;
    }
    if (allow) {
      this.eyeWitnessDetail[key] = event;
    }
  }
  async getAllEyewitness() {
    this.isLoading = true;
    try {
      let url =
        environment.API_CLAIM_REGISTRATION_SERVER_URL +
        this.claimId +
        '/eyewitness';
      let getEyewitnessResponse = await this.commonService.commonGet(url);
      this.getEyewitnessDetails = getEyewitnessResponse.body._links.item;
      if (this.getEyewitnessDetails.length == 0) {
        await this.createEyewitness();
      }
      this.isLoading = false;
    } catch (error) {
      console.log('Get all API Failed', error);
      this.isLoading = false;
    }
  }

  async getAllEyewitnessById(selectedCircleIndex) {
    this.isLoading = true;
    let eyeWitnessUuid =
      this.getEyewitnessDetails[selectedCircleIndex].summary.uuid;
    this.selectedEyewitnessUUID = eyeWitnessUuid;
    try {
      let url =
        environment.API_CLAIM_REGISTRATION_SERVER_URL +
        this.claimId +
        '/eyewitness/' +
        eyeWitnessUuid;
      let response = await this.commonService.commonGet(url);
      ///////////////////////////////////////////////
      let eyeWitnessDetail = {
        countryCode: response.body.countryCode,
        contactNumber: response.body.contactNumber,
        address: response.body.address,
        name: response.body.name,
        relationship: response.body.relationship,
        uuid: response.body.uuid,
      };
      ////////////////////////////////////////////////////////
      this.eyeWitnessDetail = cloneDeep(eyeWitnessDetail);
      this.eyewitnessDetailList[selectedCircleIndex] = cloneDeep(
        this.eyeWitnessDetail
      );
      this.isLoading = false;
    } catch (err) {
      console.log('Get all API Error ', err);
      this.isLoading = false;
    }
  }

  async selectCircle(index: number) {
    this.eyewitnessDetailList[this.selectedCircleIndex] = cloneDeep(
      this.eyeWitnessDetail
    );
    this.selectedCircleIndex = index;
    if (this.eyewitnessDetailList[this.selectedCircleIndex]) {
      this.eyeWitnessDetail = cloneDeep(
        this.eyewitnessDetailList[this.selectedCircleIndex]
      );
      this.selectedEyewitnessUUID = this.eyeWitnessDetail.uuid;
      console.log('selectCircleUUid', this.selectedEyewitnessUUID);
    } else {
      this.getAllEyewitnessById(index);
      this.eyeWitnessDetail = cloneDeep(
        this.eyewitnessDetailList[this.selectedCircleIndex]
      );
    }
  }

  async createEyewitness() {
    //////////////to show the previous data before doing patch//////////
    this.eyewitnessDetailList[this.selectedCircleIndex] = cloneDeep(
      this.eyeWitnessDetail
    );
    this.isLoading = true;
    try {
      let url =
        environment.API_CLAIM_REGISTRATION_SERVER_URL +
        this.claimId +
        '/eyewitness';
      await this.commonService.commonPost(url, {});
      await this.getAllEyewitness();
      this.selectedCircleIndex = this.getEyewitnessDetails.length - 1;
      await this.getAllEyewitnessById(this.selectedCircleIndex);
      this.isLoading = false;
    } catch (error) {
      console.log('Post API Failed', error);
      this.isLoading = false;
    }
  }
}
